<script setup lang="ts">

</script>

<template>
  <div>
    <h1>Soyez plus forts, ensemble</h1>
    <p>
      Marre de demander un dépannage aux copains sur whatsapp ?<br>
      👉 Invitez-les sur Apodis et partagez vos stocks entre-vous !
    </p>
    <br>
    <p>
      En invitant une pharmacie à vous rejoindre dans un groupe, vous rendez le moteur de recherche plus efficace :<br>
      - 📦 <strong>Accès aux stocks</strong> : Recherchez directement dans les stocks de vos pharmacies partenaires<br>
      - 🚚 <strong>Indicateur de dispo grossiste</strong> : La recherche indiquera si un membre du groupe peut commander
      le produit recherché auprès de son grossiste.
    </p>
  </div>
</template>

<style scoped>

</style>
